import React from 'react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import Loading from './Loading';

export default function MainPhotosCarousel() {
  const [photos, setPhotos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [warning, setWarning] = React.useState('');

  React.useEffect(() => {
      setLoading(true);

      axios.get('/api/site-main-photos-for-index')
      .then((response) => {
          setWarning('');
          setPhotos(response.data);
      })
      .catch((error) => {
          setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
      })
      .finally(() => {
          setLoading(false);
      });
  }, []);


  return (
    <>
      {loading ? <Loading /> 
      : warning ? <div>{warning}</div>
      : photos.length !== 0 &&
      <Swiper
        modules={[Navigation]}
        spaceBetween={10}
        slidesPerView="auto"
        navigation
      >
        {photos.map((photo) => (
          <SwiperSlide
            key={photo.id}
            style={{
              width: 'auto',
              height: 240,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '10px',
              border: '1px solid #e5e5e5',
              overflow: 'hidden'
            }}
          >
            <img
              src={photo.path}
              alt={`Фото ${photo.position ?? 'главная'}`}
              style={{
                maxHeight: '100%',
                maxWidth: '100%',
                objectFit: 'contain',
                display: 'block',
                userSelect: 'none'
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      }

      <style jsx>{`
        :global(.swiper-button-prev),
        :global(.swiper-button-next) {
          color: black !important;
          background-color: white !important;
          border-radius: 4px;
          width: 40px;
          height: 40px;
        }

        :global(.swiper-button-prev)::after,
        :global(.swiper-button-next)::after {
          font-size: 15px;
          font-weight: bold;
        }
      `}</style>
    </>
  );
}
